<template>
    <div>
      <div
        class="tw-py-2 tw-px-3 tw-rounded-[5px] tw-font-bold tw-flex tw-justify-center tw-align-center "
        :class=" data === 0 ? 'tw-bg-[#D4D4D480]': data<0 ?'tw-bg-[#FEE2E2]' : 'tw-bg-[#DCFCE7]'"
      >
        <img
          v-if="data < 0"
          src="Icons_SVG/downArrowC.svg"
          alt="Down Icon"
          class=" tw-mr-2"
        />
        <img
          v-else-if="data > 0"
          src="Icons_SVG/upArrowC.svg"
          alt="Up Icon"
          class="tw-mr-2"
        />
        <span
          :class="data==0?'':data < 0 ? 'tw-text-[#B91C1C]' : 'tw-text-[#15803D]'"
          class="tw-mt-[1px]"
        >
          {{ data }}%
        </span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "UpDownCard",
    props: {
      data: {
        type: Number,
        required: true,
      },
    },
  };
  </script>
  